import { Button, Col, Form, Input, Row, Select } from 'antd';
import { useEffect, useState } from 'react';
import { Enterprise, Tag } from '../../modules/auth';
import Title from 'antd/lib/typography/Title';
import { checkGeneralPhoneNumber } from '../../util/utils';

const { Option } = Select;

interface MyEnterpriseEditComponentProps {
  data: any;
  gongjongs: Tag[];
  subcontractTypes: Tag[];
  updatedAddress: any;
  onNext?: (data: any) => void;
  onPrev?: (data: any) => void;
  onCreate: (enterprise: Enterprise) => void;
  openSelectAddressModal: () => void;
}

function MyEnterpriseEditComponent({
  data,
  onNext,
  onPrev,
  gongjongs,
  subcontractTypes,
  updatedAddress,
  onCreate,
  openSelectAddressModal,
}: MyEnterpriseEditComponentProps) {
  const [form] = Form.useForm();
  const [mount, setMount] = useState(true);
  const [gongjongOptions, setGongjongOptions] = useState<any>();
  const [subcontractTypeOptions, setSubcontractTypeOptions] = useState<any>();
  const [regionOptions, setRegionOptions] = useState<any>();

  useEffect(() => {
    if (!mount) return;
    let children: any = [];
    for (const gongjong of gongjongs) {
      children.push(
        <Option key={gongjong.id} value={gongjong.name}>
          {gongjong.name}
        </Option>,
      );
    }
    setGongjongOptions(children);
    children = [];
    for (const mvt of subcontractTypes) {
      children.push(
        <Option key={mvt.id} value={mvt.name}>
          {mvt.name}
        </Option>,
      );
    }
    setSubcontractTypeOptions(children);
    return () => setMount(false);
  }, [gongjongs, subcontractTypes, mount]);

  useEffect(() => {
    const arrRegion: string[] = [
      '전국',
      '서울특별시',
      '부산광역시',
      '대구광역시',
      '인천광역시',
      '광주광역시',
      '대전광역시',
      '울산광역시',
      '세종특별자치시',
      '경기도',
      '강원도',
      '충청북도',
      '충청남도',
      '전라북도',
      '전라남도',
      '경상북도',
      '경상남도',
      '제주특별자치도',
    ];
    const children = [];
    for (const _region of arrRegion) {
      children.push(
        <Option key={_region} value={_region}>
          {_region}
        </Option>,
      );
    }
    setRegionOptions(children);
  }, []);

  useEffect(() => {
    if (updatedAddress) {
      form.setFieldsValue({ address: updatedAddress });
    } else {
    }
  }, [updatedAddress, form]);

  return (
    <>
      <Row justify="center" style={{ marginTop: '10px' }}>
        <Col span={18}>
          <Title level={4}>회사정보를 입력 해 주세요.</Title>
        </Col>
      </Row>
      <Form
        layout="vertical"
        form={form}
        name="control-hooks"
        onFinish={onCreate}
        initialValues={data}
      >
        <Row justify="center">
          <Col span={18}>
            <Form.Item
              name="name"
              label="회사명"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="center">
          <Col span={18}>
            <Form.Item
              name="representative"
              label="대표명"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>

        <Row justify="center">
          <Col span={18}>
            <Form.Item
              name="address"
              label="주소"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input onFocus={openSelectAddressModal} />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="center">
          <Col span={18}>
            <Form.Item name="detailAddress" label="상세주소">
              <Input placeholder="상세주소를 입력하세요." />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="center">
          <Col span={18}>
            <Form.Item
              name="corporatePhone"
              label="전화번호(회사)"
              rules={[
                {
                  required: true,
                },
                {
                  validator: (_, value) => checkGeneralPhoneNumber(value),
                },
              ]}
            >
              <Input type="text" placeholder="회사 전화 번호를 입력하세요." />
            </Form.Item>
          </Col>
        </Row>

        <Row justify="center">
          <Col span={18}>
            <Form.Item
              name="type1"
              label="회사종류"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select
                allowClear
                style={{ width: '100%' }}
                placeholder="회사종류를 선택 하세요."
                onClick={() => form.setFieldsValue({ type2: [] })}
              >
                <Option value="1">건설사</Option>
                <Option value="2">자재사</Option>
                <Option value="3">발주처</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row justify="center">
          <Col span={18}>
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, currentValues) =>
                prevValues.type1 !== currentValues.type1
              }
            >
              <Form.Item name="workPerformed" label="주력분야">
                <Select
                  mode="multiple"
                  allowClear
                  style={{ width: '100%' }}
                  placeholder="주력분야를 선택 하세요."
                >
                  {subcontractTypeOptions}
                </Select>
              </Form.Item>
            </Form.Item>
          </Col>
        </Row>
        <Row justify="center">
          <Col span={18}>
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, currentValues) =>
                prevValues.type1 !== currentValues.type1
              }
            >
              <Form.Item name="type2" label="보유면허">
                <Select
                  mode="multiple"
                  allowClear
                  style={{ width: '100%' }}
                  placeholder="보유면허를 선택 하세요."
                >
                  {gongjongOptions}
                </Select>
              </Form.Item>
            </Form.Item>
          </Col>
        </Row>
        <Row justify="center">
          <Col span={18}>
            <Form.Item
              name="region"
              label="공사가능지역"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select
                mode="multiple"
                allowClear
                style={{ width: '100%' }}
                placeholder="공사가능지역을 선택 하세요."
              >
                {regionOptions}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row justify="center" style={{ marginTop: '20px' }}>
          <Col span={8}>
            <Form.Item>
              <Row justify="center">
                <Button
                  type="primary"
                  style={{ width: '100%' }}
                  htmlType="submit"
                >
                  확인
                </Button>
              </Row>
            </Form.Item>
          </Col>
        </Row>
        <Row justify="center">
          <Col span={8}>
            <Form.Item>
              <Row justify="center">
                <Button
                  htmlType="button"
                  style={{ width: '100%' }}
                  onClick={onPrev}
                >
                  뒤로가기
                </Button>
              </Row>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  );
}

export default MyEnterpriseEditComponent;
